import { clearSWRCache, JobOptionsAction, useQueryClient, useState, useSWR, useRouter, useTranslation, useEffect, useRef, PageStyle, FieldArray, Form, Formik, FormikControl, Button, ButtonStyle, Field, cursorNone, InputError, Image, ScreeningStyle, QUESTION_TYPES, toggleDisabled, FormStyle, InputText} from '@/imports-files/pages/clients/jobs/job-options';
import AddPlusIcon from 'public/icons/thick-plus.svg';

export function ScreeningQuestions(props){

  const {formik, questionTypes, editable, formRef, job_id} = props
  const { t, i18n }  =   useTranslation();
  const [selectedOption, setSelectedOption] = useState(null);
  const [flagForRender, setFlagForRender] = useState(null);
  const [addQuestionDisabled, setAddQuestonDisabled] = useState(false)
  const [addChoiceDisabled, setAddChoiceDisabled] = useState(false)

  const options = [
    { value: 'Text (single line)', label: 'Text (single line)' },
    { value: 'Text (multiple lines) ', label: 'Text (multiple lines) ' },
    { value: 'Yes/No', label: 'Yes/No' },
  ];

  function canQuestionAdd(formik, editable){
    let screening_questions_attributes = formik.values.job.screening_questions_attributes.filter(x => !x._destroy)
    if(screening_questions_attributes.length < 10){
      return true
    }
    return false
  }

  function onAddQuestion(formik, job_id){
    setAddQuestonDisabled(true)
    let question = {
      question: '',
      question_type_id: '',
      question_type_name: '',
      mandatory: false,
      option_mandatory: false,
      _destroy: false,
      job_id: job_id,
      question_options_attributes: []
    }
    let screening_questions = formik.values.job.screening_questions_attributes
    screening_questions.push(question)
    formik.setFieldValue('job.screening_questions_attributes', [...screening_questions])
    setAddQuestonDisabled(false)
  }

  function onRemoveQuestion(formik, index){
    let screening_questions_attributes = formik.values.job.screening_questions_attributes
    formik.setFieldValue(`job.screening_questions_attributes.${index}._destroy`, true)
  }

  async function onAddChoice(formik, index){
    await setAddQuestonDisabled(true)
    let question_options_attributes = formik.values.job.screening_questions_attributes[index].question_options_attributes
    let next_order =  question_options_attributes.length > 0 ? (question_options_attributes[question_options_attributes.length - 1].order + 1) : 1
    let question_option = {option: '', _destroy: false}
    question_options_attributes.push(question_option)
    await formik.setFieldValue(`job.screening_questions_attributes.${index}.question_options_attributes`, question_options_attributes)
    await setAddQuestonDisabled(false)
  }

  async function onRemoveChoice(formik, index, option_index){
    let question_options_attributes = formik.values.job.screening_questions_attributes[index].question_options_attributes
    await formik.setFieldValue(`job.screening_questions_attributes.${index}.question_options_attributes.${option_index}._destroy`, true)
  }

  async function onQuestionTypeChanged(formik, index, question_type, t){
    let question_options_attributes = formik.values.job.screening_questions_attributes[index].question_options_attributes
    question_options_attributes = question_options_attributes.map((x) => {
      x._destroy = true
      return x
    })
    switch(question_type){
    case QUESTION_TYPES.SINGLE_LINE: case QUESTION_TYPES.MULTIPLE_LINE:
      await formik.setFieldValue(`job.screening_questions_attributes.${index}.question_options_attributes`, question_options_attributes)
      await formik.setFieldValue(`job.screening_questions_attributes.${index}.option_mandatory`, false)
      break;
    case QUESTION_TYPES.YES_NO: case QUESTION_TYPES.SINGLE_CHOICE: case QUESTION_TYPES.MULTIPLE_CHOICE:
      let question_option_1 = {option: question_type == 'yes_no' ? t('button:yes') : '', _destroy: false}
      let question_option_2 = {option: question_type == 'yes_no' ? t('button:no') : '', _destroy: false}
      question_options_attributes.push(question_option_1);
      question_options_attributes.push(question_option_2); // for adding 2 options
      await formik.setFieldValue(`job.screening_questions_attributes.${index}.question_options_attributes`, question_options_attributes)
      await formik.setFieldValue(`job.screening_questions_attributes.${index}.option_mandatory`, true)
      break;
    }
  }

  function canOptionAdd(question, editable){
    let question_options_attributes = question.question_options_attributes.filter(x => !x._destroy)
    if([QUESTION_TYPES.SINGLE_CHOICE, QUESTION_TYPES.MULTIPLE_CHOICE].includes(question.question_type_name) && question_options_attributes.length < 7){
      return true && editable
    }
    return false
  }

  function canOptionRemove(question, editable){
    let question_options_attributes = question.question_options_attributes.filter(x => !x._destroy)
    if([QUESTION_TYPES.SINGLE_CHOICE, QUESTION_TYPES.MULTIPLE_CHOICE].includes(question.question_type_name) && question_options_attributes.length > 2){
      return true && editable
    }
    return false
  }

  function optionPlaceholder(question, option_index, t){
    if(question.question_type_name == QUESTION_TYPES.YES_NO){
      let validIndexes = []
      question.question_options_attributes.map((x, op_index) => { if(!x._destroy) validIndexes.push(op_index) })
      return option_index == validIndexes[0] ? t('button:yes') : t('button:no')
    }
    else{
      return t('jobs:options:screening:add_ans_choice')
    }
  }
  return(
 <>
  <div className={`${props.ScreeningStyle.ScreeningQuestions} ScreeningQuestions`}>
        <h4 className={`${PageStyle.ClientCompany__Subheading} mb0`}>
          {t('jobs:options:screening:heading')}
        </h4>
      <div className={`${props.ScreeningStyle.ScreeningQuestions__Description}`}>
        <h5>
           {t('jobs:options:screening:subheading')}
        </h5>
      </div>

      {formik.values.job.screening_questions_attributes?.map((question, index) => {
        return !question._destroy && <div className={`${props.ScreeningStyle.ScreeningQuestions__Box}`} key={`screening_${index}`}>
          <div className={`${props.ScreeningStyle.ScreeningQuestions__BoxForm}`}>
            <div className={`w100 ${FormStyle.Form__TableCol}`}>
              <div className={`${props.ScreeningStyle.ScreeningQuestions__BoxLabel} wauto`}>
                <label className={`${FormStyle.Form__FloatingLabel}`} style={InputText(formik, `job.screening_questions_attributes.${index}.question`)}> {t('jobs:options:screening:input:question')}</label>
              </div>
              <div className={`${props.PageStyle.Form__InputSection} ${props.ScreeningStyle.ScreeningQuestions__BoxInput} removeplaceholder`}>
                <FormikControl
                    control="input"
                    className={`${props.PageStyle.Form__Input}`}
                    errorClass={`${props.PageStyle.Form__Error}`}
                    formik={formik}
                    placeholder = {t("placeholder:add_question")}
                    name={`job.screening_questions_attributes.${index}.question`}
                    style={InputError(formik, `job.screening_questions_attributes.${index}.question`)}
                    custom_class = {`FieldError`}
                    disabled = {!editable}
                  />
              </div>
              <div className={`${props.ScreeningStyle.ScreeningQuestions__BoxLabels} ${props.ScreeningStyle.ScreeningQuestions__Remove}`}>
                {editable && <div className={`${props.ScreeningStyle.ScreeningQuestions__BoxLabel} CursorPointer`} onClick={() => {
                  onRemoveQuestion(formik, index)
                }}>
                  <span className={`w100 JustifyEnd`}> {t('jobs:options:screening:remove')}</span>
                </div>}
              </div>
            </div>
            <div className={`w100 ${FormStyle.Form__TableCol}`}>
              <div className={`${props.ScreeningStyle.ScreeningQuestions__BoxLabels}`}>
                <div className={`${props.ScreeningStyle.ScreeningQuestions__BoxLabel} wauto`}>
                  <label className={`${FormStyle.Form__FloatingLabel}`} style={InputText(formik, `job.screening_questions_attributes.${index}.question_type_id`)}> {t('jobs:options:screening:input:answer_type')}</label>
                </div>
              </div>
              <div className={`${props.PageStyle.Form__InputSection} ${props.ScreeningStyle.ScreeningQuestions__BoxSelect} removeplaceholder`}>
                <FormikControl
                  control="select"
                  errorClass={`${props.PageStyle.Form__Error}`}
                  formik={formik}
                  options={questionTypes}
                  default={formik.values.job.screening_questions_attributes[index].question_type_id}
                  onChange={async(option) => {
                    await formik.setFieldValue(`job.screening_questions_attributes.${index}.question_type_id`, option.value)
                    await formik.setFieldValue(`job.screening_questions_attributes.${index}.question_type_name`, option.name)
                    await onQuestionTypeChanged(formik, index, option.name, t)
                  }}
                  name={`job.screening_questions_attributes.${index}.question_type_id`}
                  value={questionTypes.filter(option => option.value === formik.values.job.screening_questions_attributes[index].question_type_id)}
                  style={InputError(formik, `job.screening_questions_attributes.${index}.question_type_id`)}
                  custom_class = {`FieldError`}
                  custom_error_90 = {'custom_error_90'}
                  disabled = {!editable}
                />
              </div>
            </div>
            <div className={`w100 d-flex justify-content-start align-items-center`}>
              <div className={`${props.ScreeningStyle.ScreeningQuestions__BoxLabels} wauto`}>
                <div className={`${props.ScreeningStyle.ScreeningQuestions__BoxLabel}`}>
                  <span className={`w100 mb0`}> {t('jobs:options:screening:input:required')}</span>
                </div>
              </div>
              <div className={`${props.ScreeningStyle.ScreeningQuestions__ToggleSwitch}`}>
              <label className={`${props.ScreeningStyle.ScreeningQuestions__Switch} automationswitch`}>
                  <input type="checkbox" name={`job.screening_questions_attributes.${index}.mandatory`} defaultChecked={formik.values.job.screening_questions_attributes[index].mandatory} onChange={(event) => {
                          formik.setFieldValue(`job.screening_questions_attributes.${index}.mandatory`, event.target.checked)
                        }}
                        disabled = {!editable}
                        />
                      <div className={`${props.ScreeningStyle.ScreeningQuestions__Slider} automationslider automationround ${toggleDisabled(editable)}`}>
                      </div>
                  </label>
                  </div>
            </div>
            {[QUESTION_TYPES.YES_NO, QUESTION_TYPES.SINGLE_CHOICE, QUESTION_TYPES.MULTIPLE_CHOICE].includes(question.question_type_name) && <div>
              <div className={`${props.ScreeningStyle.ScreeningQuestions__BoxLabels}`}>
                  <span className={`${PageStyle.Form__Label}`}>{t('jobs:options:screening:input:answer_choice')}</span>
              </div>
              {question.question_options_attributes.map((question_option, option_index) => {
                return !question_option._destroy && <div key={`question-option-${index}-${option_index}`} className={`d-flex ${props.ScreeningStyle.ScreeningQuestions__BoxInput} removeplaceholder mb20`}>
                  <FormikControl
                    control="input"
                    errorClass={`${props.PageStyle.Form__Error}`}
                    formik={formik}
                    placeholder = {optionPlaceholder(question, option_index, t)}
                    name={`job.screening_questions_attributes.${index}.question_options_attributes.${option_index}.option`}
                    style={InputError(formik, `job.screening_questions_attributes.${index}.question_options_attributes.${option_index}.option`)}
                    custom_class = {`FieldError`}
                    maxLength = {160}
                    disabled = {!editable}
                    onChange={async(event) => {
                      await formik.setFieldValue(`job.screening_questions_attributes.${index}.question_options_attributes.${option_index}.option`, event.target.value || '')

                      // This code is being used to handle 2 options selected or not
                      if(formRef.current.values.job.screening_questions_attributes[index].question_options_attributes.filter(x => !x._destroy && x.option && (x.option.length > 0)).length < 2)
                      { await formik.setFieldValue(`job.screening_questions_attributes.${index}.option_mandatory`, true) }
                      else
                      { await formik.setFieldValue(`job.screening_questions_attributes.${index}.option_mandatory`,  false) }

                    }}
                  />
                  {canOptionRemove(question, editable) && <span className={`wauto d-flex JustifyEnd AlignCenter ml25 CursorPointer h-48`} onClick={async() => {
                    await onRemoveChoice(formik, index, option_index)
                    // This code is being used to handle 2 options selected or not
                    if(formRef.current.values.job.screening_questions_attributes[index].question_options_attributes.filter(x => !x._destroy && x.option && (x.option.length > 0)).length < 2)
                    { await formik.setFieldValue(`job.screening_questions_attributes.${index}.option_mandatory`, true) }
                    else
                    { await formik.setFieldValue(`job.screening_questions_attributes.${index}.option_mandatory`,  false) }
                  }}>
                  <Image
                      src="/icons/close.png"
                      height={14}
                      width={14}
                      alt=""
                    /></span>}
                </div>
              })
              }
            </div>}
            {canOptionAdd(question, editable) && <div className={`w100 ${props.ScreeningStyle.ScreeningQuestions__BoxChoiceButton} mt0 mb0`}>
              <Button buttonstyle={`${ButtonStyle.iconTextButton} tt-captialize-imp`} disabled={addChoiceDisabled} type="button" onClick={async() => {
                await onAddChoice(formik, index)
                // This code is being used to handle 2 options selected or not
                if(formRef.current.values.job.screening_questions_attributes[index].question_options_attributes.filter(x => !x._destroy && x.option && (x.option.length > 0)).length < 2)
                { await formik.setFieldValue(`job.screening_questions_attributes.${index}.option_mandatory`, true) }
                else
                { await formik.setFieldValue(`job.screening_questions_attributes.${index}.option_mandatory`,  false) }
              }}>
                <AddPlusIcon/>
                 {t('jobs:options:screening:add:choice')}
              </Button>
            </div>}
          </div>
        </div>
      })}
  </div>
  {canQuestionAdd(formik, editable) && <div className={`w100 ${props.ScreeningStyle.ScreeningQuestions__BoxChoiceButton} `}>
    <Button buttonstyle={`${ButtonStyle.iconTextButton}`} type="button" disabled={addQuestionDisabled || !editable}  onClick={() => onAddQuestion(formik, job_id)}>
      <AddPlusIcon/>
     {t('jobs:options:screening:add:question')}
    </Button>
  </div>}
  </>
)};
